import * as f from "react";
import { isBrowserClient as o } from "../utils/commonUtil.mjs";
function s(t, e) {
  o ? f.useLayoutEffect(t, e) : f.useEffect(t, e);
}
export {
  s as default
};
//# sourceMappingURL=useLayoutEffect.mjs.map
